import { useMutation, useQuery } from "react-query";
import { RelayApplicationStatus, createRelayAccountApplication, getRelayAccountApplication } from "services/relay";


export const useCreateRelayAccountApplication = (businessId: string) => {
  const { mutate, mutateAsync, ...rest } = useMutation(() =>
    createRelayAccountApplication(businessId),
  );

  return {
    createRelayAccountApplication: mutate,
    createRelayAccountApplicationAsync: mutateAsync,
    ...rest,
  };
};

export const useGetRelayAccountApplication = (businessId: string) => {
  const { data, ...rest } = useQuery<RelayApplicationStatus>(
    ['relayAccountApplication', businessId],
    () => getRelayAccountApplication(businessId),
    {
      enabled: !!businessId,
    },
  );

  return {
    relayAccountApplication: data,
    ...rest,
  };
}
